const BigData =()=>import('@/page/Bigdata');
const BackStage =()=>import('@/page/bigdata/backStage');
const School =()=>import('@/page/bigdata/school');
const SchoolV2 =()=>import('@/page/bigdata/schoolV2');

export default {
  path:'/bigdata',
  component:BigData,
  children:[ {
      path: 'backstage',
      name: 'backStage',
      component:BackStage,
    },{
      path: 'school',
      name: 'school',
      component:School,
    },{
      path: 'schoolV2',
      name: 'schoolV2',
      component:SchoolV2,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/bigdata.js